class WhatsIncluded extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    var _a;
    (_a = this.querySelector('[js-whats-included="show-more"]')) == null ? void 0 : _a.addEventListener(
      "click",
      () => {
        var _a2;
        (_a2 = this.querySelector('[js-whats-included="show-more"]')) == null ? void 0 : _a2.setAttribute(
          "hidden",
          ""
        );
        this.querySelectorAll('[js-whats-included="item"]').forEach((item) => {
          item.removeAttribute("hidden");
        });
      }
    );
  }
}
customElements.define("uwp-whats-included", WhatsIncluded);
